import React from 'react';
import { connect } from 'react-redux';

import { signIn, signOut } from '../../actions';
import { Button, Icon, Modal, Input } from 'semantic-ui-react';
import sha256 from 'sha256'


class AuthModule extends React.Component {
     siteKey='cc408101574fae6622507b744b865b94cfec786f9d7c1b31f6d93d79497e83ff';
     
state = {
    modelOpen: false,
    inputValue: ''
};

    onSubmitClick = () => {
        const { inputValue } = this.state;
        this.modelClose();

        if (sha256(inputValue) === this.siteKey) {
            this.onSignInClick();
        } else {            
            window.alert('Sorry this Google Id is not autorized for this site');
        }
    };
    
    modelClose = () => this.setState({ modelOpen: false });

    modelOpen = () => this.setState({ modelOpen: true });

    onSignInClick = () => this.auth.signIn();

    onSignOutClick = () => this.auth.signOut();

    onInputvalueChange = ({target}) => this.setState({ inputValue: target.value });

    onAuthChange = (isSignedIn) => {
        const { signIn, signOut } = this.props;
        if (isSignedIn) {
            const hashedGoogleId = sha256(this.auth.currentUser.get().getId());
            signIn(hashedGoogleId);
        } else {
            signOut();
        }
    };

    componentDidMount() {
        window.gapi.load('client:auth2', () => {
            window.gapi.client.init({ 
                clientId: '193797655965-qsb1vheij5on825h02u2ns28p2qtk6ip.apps.googleusercontent.com',
                scope: 'email'
            }).then(()=>{
                this.auth = window.gapi.auth2.getAuthInstance();
                this.onAuthChange(this.auth.isSignedIn.get());
                this.auth.isSignedIn.listen(this.onAuthChange);
            });
        });
    }

    render() {
        const { modelOpen, inputValue} = this.state;
        const { isSignedIn } = this.props;

        if (isSignedIn===null) {
            return (
                <Button loading>Loading</Button>
            );
        } else if (isSignedIn) {
            return (                
                <Button animated="fade" onClick={this.onSignOutClick}>
                    <Button.Content visible>
                        {this.auth.currentUser.get().getBasicProfile().getName()}
                    </Button.Content>
                    <Button.Content hidden>Sign Out</Button.Content>
                </Button>
            );
        } else {
            return (
                <React.Fragment>
                    <Button onClick={this.modelOpen}>
                        <Icon name="google"/>Sign in with Google
                    </Button>
                    <Modal 
                        open={modelOpen}
                        size="tiny"
                        onClose={this.modelClose}
                    >
                        <Modal.Header>Enter Site Id Key provided by Administrator</Modal.Header>
                        <Modal.Content>
                                <Input 
                                    fluid
                                    type="password"
                                    placeholder='Site Key...'
                                    value={inputValue} 
                                    onChange={this.onInputvalueChange}
                                />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={this.onSubmitClick} color="green">Submit</Button>
                            <Button onClick={this.modelClose}>Cancel</Button>
                        </Modal.Actions>
                    </Modal>
                </React.Fragment>
            );
        }
    }
}

const mapPropsToState = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        userId: state.auth.userId
    }
}
export default connect(mapPropsToState, { signIn, signOut })(AuthModule);